import axios from 'axios';
import { createObject } from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const consultasService = {
  async getRutas() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/rutas/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener rutas:', error);
      return [
        { id: 'au1', label: 'AU1 - Acceso Norte' },
        { id: 'au6', label: 'AU6 - Acceso Oeste' },
        { id: 'au7', label: 'AU7 - Acceso Sur' },
        { id: 'au25', label: 'AU25 - Acceso Riccheri' },
        { id: 'rn8', label: 'RN8 - Pilar - Pergamino' },
        { id: 'rn9', label: 'RN9 - Zárate - Lima' }
      ];
    }
  },

  async enviarConsulta(datosConsulta) {
    try {
      const response = await createObject('/api/consultas/', this.parseToBackendFormat(datosConsulta));

      return {
        success: true,
        data: response.data,
        message: 'Consulta enviada exitosamente'
      };
    } catch (error) {
      console.error('Error al enviar consulta:', error);
      
      if (error.response) {
        // Error del servidor
        return {
          success: false,
          error: error.response.data,
          message: error.response.data.message || 'Error en el servidor'
        };
      } else if (error.request) {
        // Error de conexión
        return {
          success: false,
          error: 'CONNECTION_ERROR',
          message: 'No se pudo conectar con el servidor'
        };
      } else {
        // Error desconocido
        return {
          success: false,
          error: 'UNKNOWN_ERROR',
          message: 'Ocurrió un error inesperado'
        };
      }
    }
  },

  parseToBackendFormat(formData) {
    return {
      apellido_nombre: formData.apellidoNombre, // "dsrt"
      captcha_token: formData.captcha_token, // ""
      codigo_area: formData.codigoArea, // "2345"
      dni: formData.dni, // "23634"
      dominio: formData.dominio, // ""
      email: formData.email, // "dfgfsdgs@dfh.com"
      fecha_envio: formData.fecha_envio, // "2025-09-17T20:55:51.349Z"
      ip_cliente: formData.ip_cliente, // "N/A"
      km: formData.km, // ""
      mensaje: formData.mensaje, // "ygghetyjfhert"
      motivo: formData.motivoConsulta, // "licitaciones"
      numero_de_tag: formData.numeroTag, // ""
      ruta: formData.ruta, // "au25"
      telefono: formData.telefono, // "346"
      telefono_completo: formData.telefono_completo, // "2345346"
    }
  },

  // Validar captcha (Google reCAPTCHA)
  async validarCaptcha(captchaToken) {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/captcha/validate/`, {
        token: captchaToken
      });
      return response.data.valid;
    } catch (error) {
      console.error('Error al validar captcha:', error);
      return false;
    }
  },

  async getMotivosConsulta() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/motivos-consulta/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener motivos:', error);
      return [
        { id: 'telepase', label: 'TelePase', campos: ['ruta', 'dominio', 'numeroTag'] },
        { id: 'exencion', label: 'Exención discapacidad', campos: ['ruta'] },
        { id: 'licitaciones', label: 'Consulta licitaciones', campos: ['ruta'] },
        { id: 'facturacion', label: 'Facturación', campos: ['ruta'] },
        { id: 'accidente', label: 'Accidente/siniestro', campos: ['ruta', 'km'] },
        { id: 'mantenimiento', label: 'Mantenimiento banquina/calzadas', campos: ['ruta'] },
        { id: 'veteranos', label: 'Veteranos Malvinas', campos: ['ruta'] }
      ];
    }
  }
};

export default consultasService;
